import { RouteObject } from "react-router-dom";
import { AllTokens } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import {
  ABSENCE_TYPE_POLICY_PATH,
  AbsenceTypeListPage,
} from "./pages/absence-type-list";

export const absencePoliticsRoutes: RouteObject[] = [
  {
    element: (
      <Guard.Redirect.IfCantModify.PageNotFound
        influencedBy={[AllTokens.EmployeesAbsencesPolicy]}
      >
        <AbsenceTypeListPage />
      </Guard.Redirect.IfCantModify.PageNotFound>
    ),
    path: ABSENCE_TYPE_POLICY_PATH,
  },
];
